import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { Amendment } from '../../../types/amendment/Amendment'
import { amendmentKeys } from '../queries/amendmentQueryKeys'
import { createAmendment } from '../service/amendmentService'

export const useCreateAmendment = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario } = useSelector(filtersSelector)
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { message } = App.useApp()

  return useMutation({
    mutationKey: ['budget', 'amendment', 'create'],
    mutationFn: (amendment: Partial<Amendment>) => createAmendment(companyId, amendment, budgetingScenario?.id),
    onSuccess: () => {
      message.success(t('messages:createSuccess', 'Created successfully'))
      queryClient.invalidateQueries({ queryKey: amendmentKeys.all })
      // Note: Financial statements invalidation is handled by global mutation observer
    },
    onError: () => {
      message.error(t('messages:createError', 'Failed to create'))
    }
  })
}
